import { useState } from "react";
import { ArrowLeft, FileText, Edit, Link } from "lucide-react";
import BrokerSync from "./BrokerSync";
import CsvImport from "./CsvImport";
import ManualImport from "./ManualImport";

const ImportTrades = ({ onBack }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const importOptions = [
    {
      id: "broker",
      title: "Broker Sync",
      description:
        "Connect directly with your broker for automatic trade import",
      icon: Link,
    },
    {
      id: "csv",
      title: "CSV Import",
      description: "Import trades from a CSV or Excel file",
      icon: FileText,
    },
    {
      id: "manual",
      title: "Manually Input",
      description: "Enter trade details manually",
      icon: Edit,
    },
  ];

  const renderOptionSelection = () => (
    <div className="import-options">
      <h2>Import Your Trades</h2>
      <p className="import-description">
        Choose how you'd like to add your trades to the system
      </p>

      <div className="options-grid">
        {importOptions.map((option) => {
          const Icon = option.icon;
          return (
            <button
              key={option.id}
              className="option-card"
              onClick={() => setSelectedOption(option.id)}
            >
              <div className="option-icon">
                <Icon size={24} />
              </div>
              <h3>{option.title}</h3>
              <p>{option.description}</p>
            </button>
          );
        })}
      </div>
    </div>
  );

  const renderSelectedOption = () => {
    switch (selectedOption) {
      case "broker":
        return <BrokerSync />;
      case "csv":
        return <CsvImport />;
      case "manual":
        return <ManualImport />;
      default:
        return null;
    }
  };

  return (
    <div className="import-trades-container">
      {/* Back Button */}
      <button
        className="back-link"
        onClick={selectedOption ? () => setSelectedOption(null) : onBack}
      >
        <ArrowLeft size={20} />
        <span>{selectedOption ? "Back to Import Options" : "Back"}</span>
      </button>

      {/* Main Content */}
      {selectedOption ? renderSelectedOption() : renderOptionSelection()}
    </div>
  );
};

export default ImportTrades;
